import { useWatch } from '../../../contexts';
import { useClauseCombinatorFieldPath } from '../fieldPaths/useClauseCombinatorFieldPath';

export const useClauseCombinatorWatch = () => {
  const fieldPath = useClauseCombinatorFieldPath();
  return useWatch({ name: fieldPath });
};
